import React, { useState } from 'react';
import { Copy, Check, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

export const StoreIdCard = ({ storeId, storeName }) => {
  const [copied, setCopied] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);

  const storeLink = `${window.location.origin}/loja/${storeId}`;

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      if (type === 'id') {
        setCopied(true);
        toast.success('ID copiado!');
        setTimeout(() => setCopied(false), 2000);
      } else {
        setCopiedLink(true);
        toast.success('Link copiado!');
        setTimeout(() => setCopiedLink(false), 2000);
      }
    });
  };

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-lg p-6 text-white">
      <h3 className="text-lg font-semibold mb-4">Sua Loja</h3>
      
      <div className="space-y-4">
        {/* Store ID */}
        <div>
          <label className="text-sm text-indigo-100 mb-2 block">ID da Loja</label>
          <div className="flex items-center space-x-2">
            <div className="flex-1 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3">
              <p className="text-xl font-mono font-bold tracking-wide" data-testid="store-id-display">
                {storeId}
              </p>
            </div>
            <Button
              onClick={() => copyToClipboard(storeId, 'id')}
              variant="secondary"
              size="sm"
              className="bg-white/20 hover:bg-white/30 text-white border-0"
              data-testid="copy-store-id-btn"
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            </Button>
          </div>
        </div>

        {/* Store Link */}
        <div>
          <label className="text-sm text-indigo-100 mb-2 block">Link da Loja</label>
          <div className="flex items-center space-x-2">
            <div className="flex-1 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3">
              <p className="text-sm font-mono truncate" data-testid="store-link-display">
                {storeLink}
              </p>
            </div>
            <Button
              onClick={() => copyToClipboard(storeLink, 'link')}
              variant="secondary"
              size="sm"
              className="bg-white/20 hover:bg-white/30 text-white border-0"
              data-testid="copy-store-link-btn"
            >
              {copiedLink ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            </Button>
          </div>
        </div>

        {/* Botão de Compartilhar */}
        <div className="pt-2">
          <Button
            onClick={() => {
              if (navigator.share) {
                navigator.share({
                  title: storeName,
                  text: `Confira minha loja no Needi!`,
                  url: storeLink
                });
              } else {
                copyToClipboard(storeLink, 'link');
              }
            }}
            className="w-full bg-white text-indigo-600 hover:bg-indigo-50"
            data-testid="share-store-btn"
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Compartilhar Loja
          </Button>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-white/20">
        <p className="text-xs text-indigo-100">
          💡 Compartilhe este ID ou link com seus clientes para que eles acessem sua vitrine
        </p>
      </div>
    </div>
  );
};
